/* eslint-disable no-unused-vars */
import ActiveFilters from "legacy/elements/explore/active-filters";
import ExploreFilters from "./filters";
import { useEffect, useState } from "react";
import { BANNER_OFFSET_HIDE } from "constants/layout-consts";
import classNames from "classnames";
import { toFarsiNumber } from "@utils/digits";
import { useExplore } from "../hooks/useExplore";
import PreferencesIcon from "@svg/new-design/preferences";
import { useLayoutContext } from "@context/layout";
import { Button } from "legacy/stories";

const ExploreSidebar = () => {
  const { isAdmin } = useLayoutContext();
  const { clearFilters, visibleActiveFilters } = useExplore();

  const [showBanner, setShowBanner] = useState(true);

  useEffect(() => {
    const scrollObserver = () => {
      setShowBanner(window.scrollY < BANNER_OFFSET_HIDE);
    };
    window.addEventListener("scroll", scrollObserver);
    return () => {
      window.removeEventListener("scroll", scrollObserver);
    };
  }, []);

  const top = isAdmin
    ? showBanner
      ? "190px"
      : "130px"
    : showBanner
      ? "116px"
      : "70px";

  const filterCount = Object.values(visibleActiveFilters || []).reduce(
    (prev, item) => prev + item.filter_value.length,
    0
  );
  return (
    <aside
      className="w-[282px] basis-[282px] sticky top-0 pl-4  overflow-y-scroll overflow-x-hidden sidebarScroll   h-full  hidden lg:block"
      style={{
        top: top,
        maxHeight: `calc(100vh - ${top})`,
      }}
    >
      <div
        className={classNames(
          "flex w-[282px] z-10    items-center top-0 justify-between sticky  bg-fds-primary",
          filterCount > 0 ? "" : "pb-3.5"
        )}
      >
        <div className="flex items-center">
          <PreferencesIcon />
          <p className="title-lg text-fds-primary mr-1.5 ">{`فیلتر‌ها ${
            filterCount > 0 ? `(${toFarsiNumber(filterCount)}) ` : ""
          }`}</p>
        </div>
        {Boolean(filterCount > 0) ? (
          <Button
            mode="noneStyle"
            label="حذف فیلتر‌ها"
            className="text-sm font-normal h-7 py-0 text-fds-brand"
            onClick={clearFilters}
          />
        ) : null}
      </div>
      <ActiveFilters />
      <ExploreFilters />
    </aside>
  );
};

export default ExploreSidebar;
